<template>
<div>
  <article class="sign-in" v-if="!isAuthenticated && !isViewOnly">
    <div class="wrapper">
      <h1>Quarantrivia</h1>
      <div id="firebaseui-auth-container"></div>
    </div>
  </article>
  <div v-if="isAuthenticated && !isViewOnly">

    <article class="sign-up" v-if="!userDetails.teamName">
      <div class="wrapper">
        <form v-on:submit.prevent="submitTeamName">
          <h3>Enter a Team Name</h3>
          <div class="item floatLabel">
            <label for="team-name">Team Name</label>
            <input type="text" id="team-name" v-model="teamName" />
          </div>
          <p v-if="teamNameError">{{teamNameError}}</p>
          <div class="buttons">
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
    </article>

    <div v-if="userDetails.teamName">

      <article class="countdown" v-if="currentRound && currentRound.countdownTimer && currentRound.countdownTimer.status != 'done'">
        <div class="msg">
          <div class="wrapper">
            <p>You have <strong v-if="currentRound.countdownTimer.time || currentRound.countdownTimer.time == 0">{{currentRound.countdownTimer.time}}</strong> seconds left to submit this round.</p>
          </div>
        </div>
      </article>

      <article class="team-name">
        <div class="wrapper">
          <ul>
            <li>
              <div class="img">
                <img v-bind:src="userDetails.profile_image" />
              </div>
              <h2 v-if="!showEditTeamName">{{userDetails.teamName}} <a href="javascript:void(0);" v-on:click="editTeamName">Change Name</a></h2>
              <a v-if="quiz.venmoId" v-bind:href="'https://venmo.com/code?user_id=' + quiz.venmoId" target="_blank" class="beer"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M18 21.224v-12.772c1.106-.594 1.707-1.762 1.707-3.104 0-1.874-1.472-3.411-3.319-3.515-.771-1.072-2.061-1.833-3.575-1.833-.971 0-1.945.322-2.746.964-1.401-.456-2.995-.092-4.051 1.042-1.423.027-2.663.527-3.366 1.75-.511.889-.586 1.892-.623 2.929-.064 1.847-2.027 1.867-2.027 4.272 0 2.019 1.542 3.559 4 2.802v7.466c0 .664-.336 1.203-1 1.203v1.572h16v-1.573c-.665 0-1-.539-1-1.203zm-16.412-10.484c.23-1.539 1.933-1.662 2.015-4 .063-1.792.22-3.414 3.193-3.126.384-.751 1.164-1.265 2.065-1.265.591 0 1.131.222 1.54.586.494-.814 1.39-1.359 2.412-1.359 1.256 0 2.319.82 2.685 1.955.214-.082.446-.126.689-.126 1.073 0 1.944.871 1.944 1.944s-.871 1.944-1.944 1.944c-.627 0-1.184-.296-1.539-.756-1.199 1.028-3.019.875-4.025-.366-.795.93-2.196 1.146-3.329.202-.38-.316-.744-.456-1.08-.456-1.389 0-2.289 2.391-1.779 4.53.666 2.802-3.164 2.407-2.847.293zm4.421 1.26c.106-.499.095-1.345-.041-1.917-.138-.577-.135-1.232.009-1.798.09-.355.21-.583.298-.709l.011.008c.765.638 1.662.976 2.594.976.588 0 1.161-.135 1.681-.388.672.402 1.447.62 2.254.62.588 0 1.166-.119 1.7-.343.48.26.921.405 1.485.419v3.132h-9.991zm12.991 7.42v-2.16c3.154-1.83 3.901-6.26 1.485-6.26h-1.485v-1.995h1.845c2.145 0 3.155 1.534 3.155 3.452 0 2.539-1.791 5.75-5 6.963z"/></svg></a>
              <form v-on:submit.prevent="submitTeamName" v-if="showEditTeamName">
                <input type="text" id="team-name" v-model="teamName" />
                <span class="actions">
                  <button>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg>
                  </button>
                </span>
                <p v-if="teamNameError">{{teamNameError}}</p>
              </form>
            </li>
          </ul>
        </div>
      </article>
      <!--
      <article class="stats">
        <div class="wrapper">
          <div class="stat">
            <span class="label">Score</span>
            <span class="number">13</span>
          </div>
          <div class="stat">
            <span class="label">Place</span>
            <span class="number">1st <span class="small">(tie)</span></span>
          </div>
        </div>
      </article>
      -->

      <article class="breadcrumbs">
        <div class="wrapper">
          <ul>
            <li v-for="(item) in quiz.rounds" v-bind:key="item.roundId" v-bind:class="{ active: item.roundId ==  quiz.activeRound }"><span>{{item.roundId}}</span><em v-if="item.maxPoints">{{item.maxPoints}}</em></li>
          </ul>
        </div>
      </article>

      <article>
        <div class="wrapper">
          <hr />
        </div>
      </article>

      <article class="quiz-answers" v-if="currentRound && !alreadySubmittedRound(currentRound.roundId)">
        <div class="wrapper">
          <h4 v-if="currentRound.roundTitle">{{currentRound.roundTitle}}</h4>
          <p v-if="currentRound.roundIntro">{{currentRound.roundIntro}}</p>
          <form v-on:submit.prevent="submitAnswers">
            
            <transition-group name="fade" tag="div">
              <div v-for="item in currentRoundQuestions" v-bind:key="item.questionId">
                <div class="box" v-if="item.hasBeenRead">
                  <div class="item">
                    <label v-bind:for="'question_'+item.questionId">{{item.question}}</label>
                    <img v-if="item.type == 'image'" v-bind:src="item.src" />
                    <audio v-if="item.type == 'mp3'" controls v-bind:src="item.src"></audio>
                    <pre v-if="item.additionalText">{{item.additionalText}}</pre>
                    <hr />
                    <input type="text" v-if="item.type == 'text' || item.type == 'image' || item.type == 'mp3'" v-bind:id="'question_'+item.questionId" v-model="currentRoundData.userAnswers[item.questionId]" placeholder="Answer" />
                    <textarea v-if="item.type == 'multiline'" v-bind:id="'question_'+item.questionId" v-model="currentRoundData.userAnswers[item.questionId]" placeholder="Answer"></textarea>
                  </div>
                </div>
              </div>
            </transition-group>

            <p v-if="!hasDoubledScore"><span class="toggleCheckbox" v-bind:class="{disabled: quiz.activeRound == quiz.rounds.length}"><input type="checkbox" id="toggle" value="true" v-model="doubleScore" v-bind:disabled="quiz.activeRound == quiz.rounds.length" /><label for="toggle">Toggle</label></span> <label for="toggle">Double Score This Round</label></p>
            
            <transition name="fade">
              <div class="buttons" v-if="currentRound.questions[currentRound.questions.length-1].hasBeenRead && !currentRoundData.completed">
                <button type="submit">Complete Round</button>
              </div>
            </transition>

            <transition name="fade">
              <div class="box alert" v-if="currentRoundData.completed">
                <p>You are about to submit your answers for round {{quiz.activeRound}}.</p>
                <p class="warning" v-if="blankAnswers"><strong>You have {{blankAnswers}} blank answer.</strong></p>
                <div class="buttons">
                  <button type="submit">Submit Answers</button>
                </div>
              </div>
            </transition>

          </form>
        </div>
      </article>

      <article class="waiting" v-if="!currentRound || alreadySubmittedRound(currentRound.roundId)">
        <div class="wrapper">
          <p v-if="quiz.venmoId">Enjoying Trivia?</p>
          <p v-if="quiz.venmoId" class="buttons"><a v-bind:href="'https://venmo.com/code?user_id=' + quiz.venmoId" target="_blank" class="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M18 21.224v-12.772c1.106-.594 1.707-1.762 1.707-3.104 0-1.874-1.472-3.411-3.319-3.515-.771-1.072-2.061-1.833-3.575-1.833-.971 0-1.945.322-2.746.964-1.401-.456-2.995-.092-4.051 1.042-1.423.027-2.663.527-3.366 1.75-.511.889-.586 1.892-.623 2.929-.064 1.847-2.027 1.867-2.027 4.272 0 2.019 1.542 3.559 4 2.802v7.466c0 .664-.336 1.203-1 1.203v1.572h16v-1.573c-.665 0-1-.539-1-1.203zm-16.412-10.484c.23-1.539 1.933-1.662 2.015-4 .063-1.792.22-3.414 3.193-3.126.384-.751 1.164-1.265 2.065-1.265.591 0 1.131.222 1.54.586.494-.814 1.39-1.359 2.412-1.359 1.256 0 2.319.82 2.685 1.955.214-.082.446-.126.689-.126 1.073 0 1.944.871 1.944 1.944s-.871 1.944-1.944 1.944c-.627 0-1.184-.296-1.539-.756-1.199 1.028-3.019.875-4.025-.366-.795.93-2.196 1.146-3.329.202-.38-.316-.744-.456-1.08-.456-1.389 0-2.289 2.391-1.779 4.53.666 2.802-3.164 2.407-2.847.293zm4.421 1.26c.106-.499.095-1.345-.041-1.917-.138-.577-.135-1.232.009-1.798.09-.355.21-.583.298-.709l.011.008c.765.638 1.662.976 2.594.976.588 0 1.161-.135 1.681-.388.672.402 1.447.62 2.254.62.588 0 1.166-.119 1.7-.343.48.26.921.405 1.485.419v3.132h-9.991zm12.991 7.42v-2.16c3.154-1.83 3.901-6.26 1.485-6.26h-1.485v-1.995h1.845c2.145 0 3.155 1.534 3.155 3.452 0 2.539-1.791 5.75-5 6.963z"/></svg> Buy {{quiz.venmoName}} a Beer</a></p>
          <p>Waiting for the next round to start...</p>
          <div class="spinner">
          </div>
        </div>
      </article>

    </div>

  </div>
  <div v-if="isViewOnly">

    <article class="breadcrumbs">
      <div class="wrapper">
        <ul v-if="quiz">
          <li v-for="(item) in quiz.rounds" v-bind:key="item.roundId" v-bind:class="{ active: item.roundId ==  quiz.activeRound }"><span>{{item.roundId}}</span><em v-if="item.maxPoints">{{item.maxPoints}}</em></li>
        </ul>
      </div>
    </article>

    <article>
      <div class="wrapper">
        <hr />
      </div>
    </article>

    <article class="quiz-answers" v-if="currentRound">
      <div class="wrapper">
        <h4 v-if="currentRound.roundTitle">{{currentRound.roundTitle}}</h4>
        <p v-if="currentRound.roundIntro">{{currentRound.roundIntro}}</p>
        <form v-on:submit.prevent="submitAnswers">
          
          <transition-group name="fade" tag="div">
            <div v-for="item in currentRoundQuestions" v-bind:key="item.questionId">
              <div class="box" v-if="item.hasBeenRead">
                <div class="item">
                  <label v-bind:for="'question_'+item.questionId">{{item.question}}</label>
                  <img v-if="item.type == 'image'" v-bind:src="item.src" />
                  <audio v-if="item.type == 'mp3'" controls v-bind:src="item.src"></audio>
                </div>
              </div>
            </div>
          </transition-group>

        </form>
      </div>
    </article>

    <article class="waiting" v-if="!currentRound">
      <div class="wrapper">
        <p v-if="quiz.venmoId">Enjoying Trivia?</p>
        <p v-if="quiz.venmoId" class="buttons"><a v-bind:href="'https://venmo.com/code?user_id=' + quiz.venmoId" target="_blank" class="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M18 21.224v-12.772c1.106-.594 1.707-1.762 1.707-3.104 0-1.874-1.472-3.411-3.319-3.515-.771-1.072-2.061-1.833-3.575-1.833-.971 0-1.945.322-2.746.964-1.401-.456-2.995-.092-4.051 1.042-1.423.027-2.663.527-3.366 1.75-.511.889-.586 1.892-.623 2.929-.064 1.847-2.027 1.867-2.027 4.272 0 2.019 1.542 3.559 4 2.802v7.466c0 .664-.336 1.203-1 1.203v1.572h16v-1.573c-.665 0-1-.539-1-1.203zm-16.412-10.484c.23-1.539 1.933-1.662 2.015-4 .063-1.792.22-3.414 3.193-3.126.384-.751 1.164-1.265 2.065-1.265.591 0 1.131.222 1.54.586.494-.814 1.39-1.359 2.412-1.359 1.256 0 2.319.82 2.685 1.955.214-.082.446-.126.689-.126 1.073 0 1.944.871 1.944 1.944s-.871 1.944-1.944 1.944c-.627 0-1.184-.296-1.539-.756-1.199 1.028-3.019.875-4.025-.366-.795.93-2.196 1.146-3.329.202-.38-.316-.744-.456-1.08-.456-1.389 0-2.289 2.391-1.779 4.53.666 2.802-3.164 2.407-2.847.293zm4.421 1.26c.106-.499.095-1.345-.041-1.917-.138-.577-.135-1.232.009-1.798.09-.355.21-.583.298-.709l.011.008c.765.638 1.662.976 2.594.976.588 0 1.161-.135 1.681-.388.672.402 1.447.62 2.254.62.588 0 1.166-.119 1.7-.343.48.26.921.405 1.485.419v3.132h-9.991zm12.991 7.42v-2.16c3.154-1.83 3.901-6.26 1.485-6.26h-1.485v-1.995h1.845c2.145 0 3.155 1.534 3.155 3.452 0 2.539-1.791 5.75-5 6.963z"/></svg> Buy Robby a Beer</a></p>
        <p>Waiting for the next round to start...</p>
        <div class="spinner">
        </div>
      </div>
    </article>
  </div>
</div>
</template>

<script>
import firebaseservice from '../services/firebaseservice'
const firebase = window.firebase;
export default {
  data: function() {
    return {
      isAuthenticated: false,
      userDetails: null,
      quiz: null,
      currentRound: null,
      currentRoundData: null,
      currentUserAnswers: [],
      teamName: null,
      allTeamNames: null,
      showEditTeamName: false,
      teamNameError: null,
      doubleScore: null,
      countdownInterval: null,
      isViewOnly: false
    };
  },
  watch: {
    'quiz.activeRound': function() {
      var _this = this;

      if (_this.isViewOnly) {
        return;
      }

      _this.currentRoundData.userAnswers = {};
      _this.currentRoundData.completed = false;
      _this.currentRoundData.submitted = false;

      firebaseservice.watchCurrentUserAnswers((currentUserAnswers) => {
        var doubleScore = true;
        for(var i=0; i<currentUserAnswers.length; i++) {
          if(currentUserAnswers[i].userDoubled == true) {
            doubleScore = false;
            break;
          }
        }
        if (currentUserAnswers.length < _this.quiz.rounds.length-1) {
          doubleScore = false;
        }
        _this.doubleScore = doubleScore;
      });

    },
    'currentRound.countdownTimer': function(newVal) {
      var _this = this,
          counter;

      if(!newVal) {
        return;
      }

      if (_this.currentRound.countdownTimer.status == 'running') {
        counter = newVal.time;
        if(_this.countdownInterval) {
          clearTimeout(_this.countdownInterval);
        }
        _this.countdownInterval = setInterval(function(){
          if(counter > 0) {
            _this.currentRound.countdownTimer.time = counter;
          } else {
            _this.currentRound.countdownTimer.time = counter;
            clearTimeout(_this.countdownInterval);
          }
          counter--;
        }, 1000);
      } else if (_this.currentRound.countdownTimer.status == 'stopped') {
        clearInterval(_this.countdownInterval);
      } else if (_this.currentRound.countdownTimer.status == 'done') {
        // Submit answers if user has not already submitted. Need to reload the currentUserAnswers from the server, in case this is a page reload.
        firebaseservice.watchCurrentUserAnswers((currentUserAnswers) => {
          _this.currentUserAnswers = currentUserAnswers;
          if (!_this.alreadySubmittedRound(_this.currentRound.roundId)) {
            _this.submitAnswers(null, true);
          }
        });
        clearInterval(_this.countdownInterval);
      }
    },
  },
  computed: {
    currentRoundQuestions: function() {
      return this.currentRound.questions.filter(function (question) {
        return question.hasBeenRead
      });
    },
    blankAnswers: function() {
      var _this = this;
      var userAnswers = Object.keys(this.currentRoundData.userAnswers).filter(function (key) {
        return _this.currentRoundData.userAnswers[key].length;
      });
      return _this.currentRound.questions.length - userAnswers.length;
    },
    hasDoubledScore: function() {
      for(var i=0; i<this.currentUserAnswers.length; i++) {
        if(this.currentUserAnswers[i].userDoubled == true) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    editTeamName: function() {
      this.showEditTeamName = true;
      this.teamName = this.userDetails.teamName;
    },
    submitTeamName: function() {
      if(this.teamName == this.userDetails.teamName) {
        this.showEditTeamName = false;
        return;
      }
      if(this.teamName == "") {
        this.teamNameError = "Please choose a team name.";
      }
      else if(this.allTeamNames.indexOf(this.teamName) !== -1) {
        this.teamNameError = "That team name already exists. Please choose a different name.";
      }
      else {
        this.showEditTeamName = false;
        this.teamNameError = null;
        this.userDetails.teamName = this.teamName;
        firebaseservice.updateUser(this.userDetails)
      }
    },
    alreadySubmittedRound: function(round) {
      for (var i=0; i<this.currentUserAnswers.length; i++) {
        if (this.currentUserAnswers[i].round == round) {
          return true;
        }
      }
      return false;
    },
    submitAnswers: function(e, force) {
      // force is used to force submit the round when time runs out
      if (!force) {
        if (!this.currentRound.questions[this.currentRound.questions.length-1].hasBeenRead) {
          console.log("Aborted Submit");
          return false;
        }
        if (!this.currentRoundData.completed) {
          this.currentRoundData.completed = true;
          return false;
        }
      }
      var answers = [];

      for (var key in this.currentRoundData.userAnswers) {
        answers.push({
          "questionId" : key,
          "answer": this.currentRoundData.userAnswers[key]
        });
      }

      console.log(answers);

      firebaseservice.insertUserAnswers(this.quiz.activeRound, answers, this.doubleScore);

      this.doubleScore = false;

      this.currentRoundData.submitted = true;

    }
  },
  mounted: function() {
    var _this = this;
    _this.currentRoundData = {
      userAnswers: {},
      completed: false,
      submitted: false
    };
        
    try {
      var parts = document.location.pathname.split('/');
      if(parts[2].toLowerCase() == 'view') {
          _this.isViewOnly = true;
      } 
    } catch(e) {
        console.log(e);
    }
    //firebaseservice.logout();
    firebaseservice.watchLatestQuiz((quiz) => {
      _this.quiz = quiz;
      _this.currentRound = null;
      for (var i=0; i<quiz.rounds.length; i++) {
        if (quiz.rounds[i].roundId == quiz.activeRound) {
          _this.currentRound = quiz.rounds[i];
          break;
        }
      }
    });
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        firebaseservice.watchCurrentUserAnswers((currentUserAnswers) => {
          _this.currentUserAnswers = currentUserAnswers;
        });
      }
    });
    firebaseservice.watchUser((user) => {
      _this.isAuthenticated = (user != null);
      _this.userDetails = user;
    });
    firebaseservice.watchTeamNames((teams) => {
      _this.allTeamNames = teams;
    });
    if(!_this.isViewOnly) {
      var ui = new window.firebaseui.auth.AuthUI(window.firebase.auth());
      ui.start('#firebaseui-auth-container', {
        signInOptions: [
            window.firebase.auth.FacebookAuthProvider.PROVIDER_ID
        ],
        callbacks: {
          signInSuccessWithAuthResult: function() {
            //_this.isAuthenticated = firebaseservice.isAuthenticated();
            return false;
          },
        },
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
